import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import api from './api'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		loading: false,
		signInError: '',
		signUpError: {},

		user: null,
	    token: Cookies.get('token')
	},
    
	mutations: {
		SET_LOADING (state, payload) {
			this._vm.$set(state, 'loading', payload)
		},

		SET_USER (state, payload) {
			this._vm.$set(state, 'user', payload)
		},

		SET_TOKEN (state, payload) {
			this._vm.$set(state, 'token', payload)
		},

		SET_SIGN_IN_ERROR (state, payload) {
			this._vm.$set(state, 'signInError', payload)
		},
        
		SET_SIGN_UP_ERROR (state, payload) {
			this._vm.$set(state, 'signUpError', payload)
		},
	},
    
	actions: {
		async fetchUser ({ commit }) {
			commit('SET_LOADING', true)
			const { data, status } = await api('get', '/web/authenticate/fetch-user')
    
			if (status) {
				commit('SET_USER', data.data)
				commit('SET_LOADING', false)
				return
			}
    
			commit('SET_USER', null)
			commit('SET_TOKEN', null)
			Cookies.remove('token')
			commit('SET_LOADING', false)
		},

		async signIn ({ commit }, payload) {
			commit('SET_LOADING', true)
			const { data, message, status } = await api('post', '/web/authenticate/local', payload)

			if (status) {
				commit('SET_SIGN_IN_ERROR', '')
				Cookies.set('token', data.data.api_token, { expires: 36500 })
				commit('SET_TOKEN', data.data.api_token)
				location.reload()
				return
			}

			commit('SET_SIGN_IN_ERROR', message || 'Something went wrong')
			commit('SET_USER', null)
			Cookies.remove('token')
			commit('SET_LOADING', false)
		},
        
		async signInFb ({ commit }, payload) {
			commit('SET_LOADING', true)
			const { data, message, status } = await api('post', '/web/authenticate/facebook', payload)

			if (status) {
				commit('SET_SIGN_IN_ERROR', '')
				Cookies.set('token', data.data.api_token, { expires: 36500 })
				commit('SET_TOKEN', data.data.api_token)
				location.reload()
				return
			}

			commit('SET_SIGN_IN_ERROR', message || 'Something went wrong')
			commit('SET_USER', null)
			Cookies.remove('token')
			commit('SET_LOADING', false)
		},
        
		async signInApple ({ commit }, payload) {
			commit('SET_LOADING', true)
			const { data, message, status } = await api('post', '/web/authenticate/apple', payload)

			if (status) {
				commit('SET_SIGN_IN_ERROR', '')
				Cookies.set('token', data.data.api_token, { expires: 36500 })
				commit('SET_TOKEN', data.data.api_token)
				location.reload()
				return
			}

			commit('SET_SIGN_IN_ERROR', message || 'Something went wrong')
			commit('SET_USER', null)
			Cookies.remove('token')
			commit('SET_LOADING', false)
		},
        
		async signUp ({ commit }, payload) {
			commit('SET_LOADING', true)
			payload.commit = commit
			const { error, status } = await api('post', '/web/authenticate/signup', payload)
    
			if (status) {
				commit('SET_SIGN_UP_ERROR', {})
				commit('SET_LOADING', false)
				return true
			}
    
			commit('SET_SIGN_UP_ERROR', error)
			commit('SET_LOADING', false)
			return false
		},
        
		async forgotPass ({ commit }, payload) {
			commit('SET_LOADING', true)
			payload.commit = commit
			const { data, status } = await api('post', '/web/authenticate/forgot-password', payload)
    
			if (status && data.status !== 204) {
				commit('SET_LOADING', false)
				return ''
			}
    
			commit('SET_LOADING', false)
			return 'No Record Found'
		},
        
		async changePass ({ commit }, payload) {
			commit('SET_LOADING', true)
			payload.commit = commit
			const { data, error, status } = await api('post', '/web/authenticate/change-password', payload)
    
			if (status) {
				Cookies.set('token', data.data.api_token, { expires: 36500 })
				commit('SET_TOKEN', data.data.api_token)
				location.reload()
				return null
			}
    
			commit('SET_LOADING', false)
			return error
		},
        
		async logout ({ commit }) {
			await api('post', '/web/authenticate/logout')
			commit('SET_USER', null)
			commit('SET_TOKEN', null)
			Cookies.remove('token')
			location.reload()
		},
        
		async getPlanList ({ commit }) {
			commit('SET_LOADING', true)
			const { data, status } = await api('get', '/web/moodmix/subscription-list')
    
			if (status) {
				commit('SET_LOADING', false)
				return data.data.data
			}
    
			commit('SET_LOADING', false)
			return []
		},
        
		async getPlan ({ commit }, payload) {
			console.log(payload)
			commit('SET_LOADING', true)
			const { data, status } = await api('get', '/web/moodmix/subscription-view', payload)
    
			if (status) {
				commit('SET_LOADING', false)
				return data.data
			}
    
			commit('SET_LOADING', false)
			return null
		},
        
		async subscribe ({ commit }, payload) {
			// commit('SET_LOADING', true)
			payload.commit = commit
			const { data, status } = await api('post', '/web/moodmix/subscribe', payload)
    
			if (status) {
				commit('SET_LOADING', false)
				return {status: true, end: data.data.subscription_end}
			}
    
			commit('SET_LOADING', false)
			return {status: false}
		},
	},
    
	getters: {
		isLoggedIn: state => state.user !== null
	}
})
